type StorageSpace = overwolf.extensions.io.enums.StorageSpace;
type ReadFileContentsResult = overwolf.io.ReadFileContentsResult;

export interface GetStoragePathResult extends overwolf.Result {
  path: string;
}

// -----------------------------------------------------------------------------
export class OWExtensionsIO {
  // ---------------------------------------------------------------------------
  public static async readTextFile(space: StorageSpace, filePath: string)
    : Promise<ReadFileContentsResult> {
    return new Promise(resolve => {
      overwolf.extensions.io.readTextFile(space, filePath, result => {
        return resolve({
          ...result,
          status: ''
        }
        );
      });
    });
  }

  // ---------------------------------------------------------------------------
  public static async writeTextFile(
    space: StorageSpace,
    filePath: string,
    content: string
  ): Promise<boolean> {
    return new Promise(resolve => {
      overwolf.extensions.io.writeTextFile(space, filePath, content, result => {
        return resolve(result.success);
      });
    });
  }

  // ---------------------------------------------------------------------------
  public static async getStoragePath(
    space: StorageSpace
  ): Promise<GetStoragePathResult> {
    return new Promise(resolve => {
      overwolf.extensions.io.getStoragePath(space, result => {
        return resolve(result);
      });
    });
  }

}
